import React, { useState, useEffect } from "react";
import {
    Table,
    Card,
    Button,
    Modal,
    Form,
    Input,
    message,
    Spin,
} from "antd";
import {
    PlusOutlined,
    SearchOutlined,
    CloseOutlined,
} from "@ant-design/icons";
import useApis from "../apis/useApis";
import appConstant from "../json/appConstant.json";

const PropertyType = ({ isDarkMode }) => {
    const [form] = Form.useForm();
    const [categories, setCategories] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [isDataLoading, setIsDataLoading] = useState(false);

    const { jsonApi } = useApis();

    useEffect(() => {
        fetchCategories(pagination.current, pagination.pageSize, search);
    }, [pagination.current, pagination.pageSize, search]);

    const fetchCategories = async (page, pageSize, search = "") => {
        setIsDataLoading(true);
        const params = {
            page,
            pageSize,
            search,
        };

        const response = await jsonApi(appConstant.PropertyType, params, {}, null);

        if (response?.data?.code === 200 && response?.data?.status === "success") {
            const data = response.data.data.categories || response.data.data;
            setCategories(
                data.map((cat) => ({
                    key: cat.id,
                    id: cat.id,
                    PropertyType: cat.PropertyType,
                    PTypeID: cat.PTypeID,
                    TransDate: cat.TransDate,
                }))
            );
            setPagination((prev) => ({
                ...prev,
                total: response.data.data.total || data.length,
            }));
        }
        setIsDataLoading(false);
    };

    const handleAddCategory = async (values) => {
        setLoading(true);
        try {
            const response = await jsonApi(
                appConstant.createPropertyType,
                null,
                { name: values.name },
                null
            );

            if (response.data.code === 200) {
                message.success("Property Type added successfully");
                fetchCategories(pagination.current, pagination.pageSize);
                setIsModalVisible(false);
                form.resetFields();
            } else {
                message.error(response.message || "Failed to add property type");
            }
        } catch (error) {
            console.error("Add Property Type Error:", error);
            message.error("An error occurred");
        }
        setLoading(false);
    };

    const columns = [
        {
            title: "S.No",
            key: "serialNumber",
            render: (_, __, index) =>
                (pagination.current - 1) * pagination.pageSize + index + 1,

        },
        {
            title: "Property Type",
            dataIndex: "PropertyType",
            key: "PropertyType",
            sorter: (a, b) => a.PropertyType.localeCompare(b.PropertyType),
        },
        {
            title: "Property Type Id",
            dataIndex: "PTypeID",
            key: "PTypeID",

        },
        {
            title: "TransDate",
            dataIndex: "TransDate",
            key: "TransDate",
            render: (date) => new Date(date).toLocaleDateString(),
            sorter: (a, b) => new Date(a.TransDate) - new Date(b.TransDate),
            width: "20%",
        }

    ];

    return (
        <div style={{ padding: 24 }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 16,
                }}
            >
                <h2 style={{ color: isDarkMode ? "#fff" : "#000" }}>
                    Property Type
                </h2>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setIsModalVisible(true)}
                >
                    Add Property Type
                </Button>
            </div>

            <Input
                placeholder="Search property type..."
                prefix={<SearchOutlined />}
                value={search}
                onChange={(e) => {
                    setSearch(e.target.value);
                    setPagination((prev) => ({ ...prev, current: 1 }));
                }}
                suffix={
                    search && (
                        <Button
                            type="text"
                            icon={<CloseOutlined />}
                            onClick={() => {
                                setSearch("");
                                setPagination((prev) => ({ ...prev, current: 1 }));
                            }}
                        />
                    )
                }
                style={{ width: 300, marginBottom: 16 }}
            />

            <Card
                style={{
                    background: isDarkMode ? "#1f1f1f" : "#fff",
                }}
            >
                <Spin spinning={isDataLoading}>
                    <Table
                        columns={columns}
                        dataSource={categories}
                        pagination={{
                            current: pagination.current,
                            pageSize: pagination.pageSize,
                            total: pagination.total,
                            showSizeChanger: true,
                            pageSizeOptions: ["10", "20", "50"],
                            onChange: (page, pageSize) => {
                                setPagination({ current: page, pageSize });
                            },
                        }}
                        rowKey="id"
                    />
                </Spin>
            </Card>

            <Modal
                visible={isModalVisible}
                title="Add Property Type"
                onCancel={() => {
                    setIsModalVisible(false);
                    form.resetFields();
                }}
                footer={[
                    <Button
                        key="cancel"
                        onClick={() => {
                            setIsModalVisible(false);
                            form.resetFields();
                        }}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={loading}
                        onClick={() => form.submit()}
                    >
                        Add
                    </Button>,
                ]}
            >
                <Form form={form} layout="vertical" onFinish={handleAddCategory}>
                    <Form.Item
                        name="PropertyType"
                        label="Property Type"
                        rules={[
                            { required: true, message: "Please enter a property type" },
                            { max: 50, message: "Maximum 50 characters allowed" },
                            {
                                pattern: /^[A-Za-z\s]+$/,
                                message: "Only alphabets and spaces are allowed",
                            },
                        ]}
                    >
                        <Input placeholder="Enter property type" />
                    </Form.Item>

                    <Form.Item
                        name="PTypeID"
                        label="Property Type Id"
                        rules={[
                            { required: true, message: "Please enter a property type id" },
                            // { max: 50, message: "Maximum 50 characters allowed" },

                        ]}
                    >
                        <Input placeholder="Enter property type id" />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default PropertyType;
